import { render } from "./CategoryTag.vue?vue&type=template&id=4eed5794&scoped=true"
import script from "./CategoryTag.vue?vue&type=script&lang=js"
export * from "./CategoryTag.vue?vue&type=script&lang=js"

import "./CategoryTag.vue?vue&type=style&index=0&id=4eed5794&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eed5794"]])

export default __exports__